import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
import { goToCheckout } from '../utils/checkout';
export function Hero() {
  const scrollToOffer = () => {
    goToCheckout();
  };
  return <section className="relative pt-20 pb-16 md:pt-32 md:pb-24 overflow-hidden" data-id="element-53">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-54">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center" data-id="element-55">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="order-2 md:order-1" data-id="element-56">
            <span className="inline-block py-1 px-3 rounded-full bg-mint/50 text-navy text-sm font-medium mb-6 tracking-wide uppercase" data-id="element-57">
              Cero Niebla Mental
            </span>
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-6" data-id="element-58">
              Recupera tu agudeza mental y elimina la "nube" de tu cabeza en
              menos de 48 horas.
            </h1>
            <h2 className="text-lg md:text-xl text-navy/80 mb-8 font-sans font-light leading-relaxed" data-id="element-59">
              El protocolo práctico de rescate cognitivo diseñado para mujeres
              profesionales y estudiantes que necesitan rendir al máximo sin
              colapsar.
            </h2>
            <Button onClick={scrollToOffer} className="w-full sm:w-auto" data-id="element-60">
              QUIERO RECUPERAR MI ENFOQUE AHORA
            </Button>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="order-1 md:order-2 relative" data-id="element-61">
            <div className="absolute inset-0 bg-mint rounded-3xl transform rotate-3 scale-105 opacity-50" data-id="element-62"></div>
            <img src="https://cdn.magicpatterns.com/uploads/266geU2FYhmcj7MiLBUnan/tamano_1x1_con_una_mujer.png" alt="eBook Cero Niebla Mental mostrado en tablet, laptop y smartphone" className="relative rounded-3xl shadow-2xl w-full object-cover z-10" data-id="element-63" />
          </motion.div>
        </div>
      </div>
    </section>;
}